import {Component, ViewEncapsulation} from '@angular/core';
import {ApiService} from '../../../../shared/services/api.service';
import {EnrollService} from '../../../../shared/services/enroll.service';

@Component({
  selector: 'app-activation-step-draw-signature',
  templateUrl: './activation-step-draw-signature.component.html',
  styleUrls: ['./activation-step-draw-signature.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ActivationStepDrawSignatureComponent {
  constructor(public api: ApiService, 
    public enroll: EnrollService) {
    if(this.api.userInfo.nationalNumber && this.api.userRole.isCustomer) {
      this.api.setPrincipalMode = true;
    }
  }

  ngOnDestroy() {
    this.api.setPrincipalMode = false;
  }

  setSignature(signature: string) {
    this.enroll.form.controls[this.enroll.fc.SIGNATURE].setValue(signature);
  }
}
